import React from "react";
import { Box, Button } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../shared/hooks/sharedHooks";
import MultipleSelectFilter from "../../shared/components/MultipleSelectFilter";
import PriceRangeFilter from "../../shared/components/PriceRangeFilter";
import { country, CountryCode } from "../../../shared/models/countryModels";
import { CustomerProductSuppliersState, SupplierFiltersQuery } from "../models/models";
import { changeProductSupplierFiltersQuery } from "../customerProductSuppliersSlice";
import useTranslation from "../../../shared/hooks/useTranslation";

const ProductSupplierFilters = () => {
  const { filters, filtersQuery } = useAppSelector<CustomerProductSuppliersState>(
    (state: any) => state.customerProductSuppliers);
  const dispatch = useAppDispatch();
  const { translate } = useTranslation("marketplace");
  const { translate: tCommon } = useTranslation("common");

  const showClearFilterButton =
    filtersQuery.minPrice > 0 ||
    filtersQuery.maxPrice > 0 ||
    filtersQuery.countryIds?.length ||
    filtersQuery.conditionCodes?.length ||
    filtersQuery.deliveryCodes?.length ||
    filtersQuery.groupIds?.length;

  const handleFilterClear = () => {
    const newFiltersQuery = {
      ...filtersQuery,
      minPrice: undefined,
      maxPrice: undefined,
      countryIds: [],
      deliveryCodes: [],
      conditionCodes: [],
      groupIds: []
    };

    dispatch(changeProductSupplierFiltersQuery(newFiltersQuery));
  };

  const handleFilterChange = (newFiltersQuery: SupplierFiltersQuery) => {
    dispatch(changeProductSupplierFiltersQuery(newFiltersQuery));
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <Box className="px-4" sx={{ width: "240px", paddingTop: "20px" }}>
      <Box className="flex items-center justify-between">
        <Box className="text-18-bold" color="#333333" sx={{ padding: "6px 0" }}>
          {translate("filterBy")}
        </Box>

        {!!showClearFilterButton && (
          <Button variant="text" className="text-14-medium" onClick={handleFilterClear}>
            {translate("clearAll")}
          </Button>
        )}
      </Box>

      <Box className="flex flex-col gap-2 mt-4">
        <PriceRangeFilter
          min={filters.minPrice}
          max={filters.maxPrice}
          value={[filtersQuery.minPrice || filters.minPrice, filtersQuery.maxPrice || filters.maxPrice]}
          onChange={(values) => handleFilterChange({ ...filtersQuery, minPrice: values[0], maxPrice: values[1] })}
        />
        <MultipleSelectFilter
          parameters={filters.countries}
          title={translate("supplierLocation")}
          renderParameterName={parameter => country(parameter.id as CountryCode)?.name}
          onChange={(values) => handleFilterChange({ ...filtersQuery, countryIds: values as number[] })}
        />
        <MultipleSelectFilter
          parameters={filters.conditions}
          title={tCommon("condition")}
          onChange={(values) => handleFilterChange({ ...filtersQuery, conditionCodes: values as number[] })}
        />
      </Box>
    </Box>
  );
};

export default ProductSupplierFilters;